import React, { useState, useEffect } from "react";
import Modal from "./components/Modal";

const WorkItems = ({ item }) => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const handleClickOutside = (event) => {
    if (event.target.id === "modal") {
      setToggleState(0);
    }
  };

  useEffect(() => {
    if (toggleState === 1) {
      document.body.style.overflow = "hidden";
      document.addEventListener("click", handleClickOutside);
    } else {
      document.body.style.overflow = "visible";
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [toggleState]);

  return (
    <div className="work__card" key={item.id}>
      <section id="portfolio">
        <div className="flex flex-col gap-4">
          <img
            src={item.image}
            alt=""
            className="work__img"
            onClick={() => toggleTab(1)}
          />
          <h3
            className="work__title cursor-pointer"
            onClick={() => toggleTab(1)}
          >
            {item.title}
          </h3>
        </div>

        <div className="work__main-buttons">
          <span className="work__button w-full" onClick={() => toggleTab(1)}>
            Details
            <i className="bx bx-dots-horizontal-rounded work__button-icon"></i>
          </span>
          {item.link && (
            <a
              href={item.link}
              className="work__button"
              rel="noreferrer"
              target="_blank"
            >
              Demo <i className="bx bx-play-circle work__button-icon"></i>
            </a>
          )}
        </div>

        <Modal
          item={item}
          toggleTab={toggleTab}
          toggleState={toggleState}
          id="modal"
        />
      </section>
    </div>
  );
};

export default WorkItems;
